import { startOfDay, addMonths, isBefore, isAfter, isDate, isValid, subMonths, endOfDay } from "date-fns";
import { requiredMessage, pleaseEnterAMessage, capitalise } from "../utils/common";
var VARIANTS = {
  ARHI: "cover start date",
  IAP: "date"
};
var defaultFutureLimitMessage = function defaultFutureLimitMessage(field, months) {
  return "".concat(capitalise(field), " cannot be more than ").concat(months, " month").concat(months !== 1 ? "s" : "", " in the future.");
};
var arhiFutureLimitMessage = function arhiFutureLimitMessage(field, months) {
  return months === 1 ? "Please choose a ".concat(field, " within the next month.") : defaultFutureLimitMessage(field, months);
};
var pastLimitMessage = function pastLimitMessage(field, months) {
  return "".concat(capitalise(field), " cannot be").concat(months ? " more than ".concat(months, " month").concat(months !== 1 ? "s" : "") : "", " in the past.");
};
var VARIANT_FUTURE_LIMIT_FUNCTION = {
  ARHI: arhiFutureLimitMessage,
  GU: defaultFutureLimitMessage,
  IMAN: defaultFutureLimitMessage,
  IWHI: defaultFutureLimitMessage,
  ISHI: defaultFutureLimitMessage,
  IAP: defaultFutureLimitMessage
};
var VARIANT_REQUIRED_FUNCTION = {
  ARHI: requiredMessage,
  IAP: pleaseEnterAMessage
}; //todo: why is funnel defaulted to ISHI in validCoverEndDate but ARHI in validCoverStartDate
var validCoverStartDate = function validCoverStartDate(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var fieldName = arguments.length > 2 ? arguments[2] : undefined;
  var maxDateInMonths = arguments.length > 3 ? arguments[3] : undefined;
  var minDateInMonths = arguments.length > 4 ? arguments[4] : undefined;
  var currentMinDate = arguments.length > 5 ? arguments[5] : undefined;
  var error; // eslint-disable-line init-declarations
  var field = fieldName || VARIANTS[funnel] || VARIANTS.ARHI;
  if (!currentMinDate) currentMinDate = new Date();
  var minDateOffset = minDateInMonths ? minDateInMonths : 0;
  var maxDateOffset = maxDateInMonths ? maxDateInMonths : 0;
  var minDate = startOfDay(subMonths(currentMinDate, minDateOffset));
  var maxDate = endOfDay(addMonths(currentMinDate, maxDateOffset));
  if (!value) {
    var requiredFunction = VARIANT_REQUIRED_FUNCTION[funnel] || VARIANT_REQUIRED_FUNCTION.ARHI;
    error = requiredFunction(field);
  } // date must be a date object
  if (value && !isDate(value) && typeof value === "string") {
    error = "".concat(capitalise(field), " must be a valid date.");
  } else {
    // date must be a real date
    if (value && !isValid(value)) {
      error = "".concat(capitalise(field), " must be a valid date.");
    } // date must not be before min date
    if (value && typeof value !== "string" && isBefore(value, minDate)) {
      error = pastLimitMessage(field, minDateOffset);
    } // date must not be beyond the allowed date range
    if (value && typeof value !== "string" && isAfter(value, maxDate)) {
      var messageFunction = VARIANT_FUTURE_LIMIT_FUNCTION[funnel] || VARIANT_FUTURE_LIMIT_FUNCTION.ARHI;
      error = messageFunction(field, maxDateOffset);
    }
  }
  return error;
};
export default validCoverStartDate;